import { createSlice } from "@reduxjs/toolkit"

const facebookPagesSlice = createSlice({
  name: "facebookPages",
  initialState: {
    facebookPages: null,
    getFacebookPagesLoading: false,
    instagramIds: null,
    getInstagramIdsLoading: false,
    businessManagerDetails: null,
    getBusinessManagerIdLoading: false,
    instagramAccountDetails: [],
    getInstagramAccountDetailsLoading: false,
    adImages: [],
    adImagesLoading: false,
    adImagesError: null,
    adVideosLoading: false,
    adVideosError: null,
  },
  reducers: {
    getFacebookPagesLoading: (state) => {
      state.getFacebookPagesLoading = true
    },
    getFacebookPagesSuccess: (state, action) => {
      state.facebookPages = action.payload
      state.getFacebookPagesLoading = false
    },
    getFacebookPagesFailure: (state) => {
      state.getFacebookPagesLoading = false
    },
    getInstagramIdsLoading: (state) => {
      state.getInstagramIdsLoading = true
    },
    getInstagramIdsSuccess: (state, action) => {
      state.instagramIds = action.payload
      state.getInstagramIdsLoading = false
    },
    getInstagramIdsFailure: (state) => {
      state.getInstagramIdsLoading = false
    },
    getBusinessManagerIdLoading: (state) => {
      state.getBusinessManagerIdLoading = true
    },
    getBusinessManagerIdSuccess: (state, action) => {
      state.businessManagerDetails = action.payload
      state.getBusinessManagerIdLoading = false
    },
    getBusinessManagerIdFailure: (state) => {
      state.getBusinessManagerIdLoading = false
    },
    getInstagramAccountDetailsLoading: (state) => {
      state.getInstagramAccountDetailsLoading = true
    },
    getInstagramAccountDetailsSuccess: (state, action) => {
      // Check if the account already exists in the array by ID
      const existingIndex = state.instagramAccountDetails.findIndex(
        account => account.id === action.payload.id
      );
      
      if (existingIndex >= 0) {
        // Update existing account instead of adding a duplicate
        state.instagramAccountDetails[existingIndex] = action.payload;
      } else {
        // Add new account to the array
        state.instagramAccountDetails.push(action.payload);
      }
      
      state.getInstagramAccountDetailsLoading = false
    },
    getInstagramAccountDetailsFailure: (state) => {
      state.getInstagramAccountDetailsLoading = false
    },
    uploadAdImageStart: (state) => {
      state.adImagesLoading = true
      state.adImagesError = null
    },
    uploadAdImageSuccess: (state, action) => {
      state.adImagesLoading = false
      state.adImages.push(action.payload)
    },
    uploadAdImageFailure: (state, action) => {
      state.adImagesLoading = false
      state.adImagesError = action.payload
    },
    uploadAdVideoStart: (state) => {
      state.adVideosLoading = true
      state.adVideosError = null
    },
    uploadAdVideoSuccess: (state) => {
      state.adVideosLoading = false
    },
    uploadAdVideoFailure: (state, action) => {
      state.adVideosLoading = false
      state.adVideosError = action.payload
    },
    clearInstagramAccountDetails: (state) => {
      state.instagramAccountDetails = []
    },
  },
})

export const {
  getFacebookPagesLoading,
  getFacebookPagesSuccess,
  getFacebookPagesFailure,
  getInstagramIdsLoading,
  getInstagramIdsSuccess,
  getInstagramIdsFailure,
  getBusinessManagerIdLoading,
  getBusinessManagerIdSuccess,
  getBusinessManagerIdFailure,
  getInstagramAccountDetailsLoading,
  getInstagramAccountDetailsSuccess,
  getInstagramAccountDetailsFailure,
  uploadAdImageStart,
  uploadAdImageSuccess,
  uploadAdImageFailure,
  uploadAdVideoStart,
  uploadAdVideoSuccess,
  uploadAdVideoFailure,
  clearInstagramAccountDetails,
} = facebookPagesSlice.actions

export default facebookPagesSlice.reducer
